// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectProduct_custom-select__W+y56","header-select":"SelectProduct_header-select__f640t"};